/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Ce } from './Ce';

class SurveyItem extends Ce {
    constructor() {
        super();
        this.baseUrl += '/surveyItem';
    }

    data({ surveyId, surveyItemSn, fullName, mobile, surveyItemStatus, currentPage, pageSize } = {}) {
        return super.get('/data', {
            surveyId,
            surveyItemSn,
            fullName,
            mobile,
            surveyItemStatus,
            currentPage,
            pageSize,
        });
    }

    surveyStatList({ surveyId } = {}) {
        return super.get('/surveyStatList', {
            surveyId,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id });
    }
}

export default new SurveyItem();
export { SurveyItem };
